module.exports = __webpack_public_path__ + "static/media/c-more-series.0c6f1d4d.png";